// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V6uZM","field":"styles_field__2n9W7","fieldCol":"styles_fieldCol__326oh","diffCol":"styles_diffCol__1j1Vt","diff":"styles_diff__1lDMo"};